import mutations from './drug.mutations'
import actions from './drug.actions'
import getters from './drug.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
